

<div class="image-player-container">
  {{zones | json}}
  <div [ngClass]="{'image-player':aspectRatio=='16:9','image-player-sq':aspectRatio=='square','image-player-43':aspectRatio=='14:3'}">
    <div class="image-player-inner-img" *ngIf="src != null">
      <div class="demo-img-container">
        <button *ngIf="showMetaData" class="hide-detection btn btn-outline-purple" 
          (mouseenter)="showOverlay = false"
          (mouseleave)="showOverlay = true" 
          (click)="toggleOverlay = !toggleOverlay">
          <i class="fa fa-eye" [ngClass]="{'fa-eye': showOverlay && toggleOverlay,'fa-eye-slash':!showOverlay || !toggleOverlay}"></i>
        </button>
        
        <div class="demo-img-wrapper"
             [class.dragging]="isDragging"
             [style.transform]="getTransformStyle()"
             (wheel)="onWheel($event)"
             (dblclick)="onDoubleClick($event)"
             (mousedown)="onMouseDown($event)"
             (mousemove)="onMouseMove($event)"
             (mouseup)="onMouseUp($event)"
             (mouseleave)="onMouseUp($event)"
             (touchstart)="onTouchStart($event)"
             (touchmove)="onTouchMove($event)"
             (touchend)="onTouchEnd($event)">
          
          <img #imageSource id="imageSource" [attr.src]="src" (load)="onImageLoad($event)" (mousemove)="onPointerEvent($event)" (click)="onImageClick($event)"/>

          <ng-container *ngIf="showOverlay && toggleOverlay && showMetaData">
            <div *ngFor="let o of overlays" class="object-rectangle" style="left:{{o.x}}%; top:{{o.y}}%; width:{{o.w}}%; height:{{o.h}}%">
              <table class="table-naked object-info">
                <tbody>
                  <tr>
                    <td>{{(o.confidence * 100).toFixed(0)}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="showZones">
            <div *ngFor="let o of _zones">
              <div (click)="selectZone(o)" [ngClass]="{'selected-zone': o == selectedZone}"  
                class="object-rectangle object-zone" 
                style="left:{{o.left}}%; top:{{o.top}}%; width:{{o.width}}%; height:{{o.height}}%">
                <ng-container *ngIf="o == selectedZone">
                  <div class="zone-resize-handle zone-resize-handle-top" (pointerdown)="onZoneResizeStart($event, o, 'top')"></div>
                  <div class="zone-resize-handle zone-resize-handle-right" (pointerdown)="onZoneResizeStart($event, o, 'right')"></div>
                  <div class="zone-resize-handle zone-resize-handle-bottom" (pointerdown)="onZoneResizeStart($event, o, 'bottom')"></div>
                  <div class="zone-resize-handle zone-resize-handle-left" (pointerdown)="onZoneResizeStart($event, o, 'left')"></div>
                </ng-container>
                <span class="zone-coordinate zone-coordinate-top-left">
                  ({{ o.left | number:'1.1-1' }}%, {{ o.top | number:'1.1-1' }}%)
                </span>
                <span class="zone-coordinate zone-coordinate-top-right">
                  ({{ (o.left + o.width) | number:'1.1-1' }}%, {{ o.top | number:'1.1-1' }}%)
                </span>
                <span class="zone-coordinate zone-coordinate-bottom-left">
                  ({{ o.left | number:'1.1-1' }}%, {{ (o.top + o.height) | number:'1.1-1' }}%)
                </span>
                <span class="zone-coordinate zone-coordinate-bottom-right">
                  ({{ (o.left + o.width) | number:'1.1-1' }}%, {{ (o.top + o.height) | number:'1.1-1' }}%)
                </span>
                <span class="zone-confidence">{{ o.confidence | number:'1.0-1' }}%</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="showLineAt">
            <div class="object-line" style="left:{{showLineAt.percent}}%; top:0%; width:0px; height:100%">
              <table class="table-naked object-info">
                <tbody>
                  <tr>
                    <td>{{showLineAt.deg}}*</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
          
        </div>
      </div>

      

    </div>
    <div *ngIf="selectedZone && showZones" class="actions">
      <div> 
        <table>
          <tr>
            <td>{{selectedZone.id}}</td>
            <td>Location</td>
            <td>Width</td>
            <td>Height</td>
            <td>Confidence</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <button class="btn btn-sm btn-danger mr-2" (click)="deleteZone(selectedZone)"><i class="fa fa-trash"></i></button>  
            </td>
            <td>
              <button class="btn btn-sm btn-primary" (click)="zoneLeftFull(selectedZone)"><i class="fa fa-angles-left"></i></button>  
              <button class="btn btn-sm btn-primary" (click)="zoneLeft(selectedZone, 0.1)" (dblclick)="zoneLeft(selectedZone, 2)"><i class="fa fa-arrow-left"></i></button>  
              <button class="btn btn-sm btn-primary" (click)="zoneRight(selectedZone)"><i class="fa fa-arrow-right"></i></button> 
              <button class="btn btn-sm btn-primary" (click)="zoneUpFull(selectedZone)"><i class="fa fa-angles-up"></i></button> 
              <button class="btn btn-sm btn-primary" (click)="zoneUp(selectedZone, 0.1)" (dblclick)="zoneUp(selectedZone, 2)"><i class="fa fa-arrow-up"></i></button> 
              <button class="btn btn-sm btn-primary" (click)="zoneDown(selectedZone)"><i class="fa fa-arrow-down"></i></button> 
            </td>
            <td>
              <button class="btn btn-sm btn-primary" (click)="zoneWidthFull(selectedZone,1)"><i class="fa fa-arrows-left-right"></i></button> 
              <button class="btn btn-sm btn-primary" (click)="zoneWidth(selectedZone,1)"><i class="fa fa-plus"></i></button> 
              <button class="btn btn-sm btn-primary" (click)="zoneWidth(selectedZone,-1)"><i class="fa fa-minus"></i></button> 
            </td>
            <td>
              <button class="btn btn-sm btn-primary" (click)="zoneHeight(selectedZone,1)"><i class="fa fa-plus"></i></button>        
              <button class="btn btn-sm btn-primary" (click)="zoneHeight(selectedZone,-1)"><i class="fa fa-minus"></i></button>        
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" min="0" max="100" width="30" [(ngModel)]="selectedZone.confidence"/>
            </td>
            
            <td>
              <button class="btn btn-sm btn-success" (click)="zoneSave(selectedZone)"><i class="fa fa-save"></i></button>                      
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="image-player-inner" *ngIf="src == null">
      <ng-container>
        <span *ngIf="isLoaded && src == null">No Image</span>
        <span *ngIf="!isLoaded && src == null">Loading...</span>
      </ng-container>
    </div>
  
</div>
